import type { PropsWithChildren } from "react";

// Tailwind v4 entry imported as plain CSS so @tailwindcss/vite resolves the
// @config/@source paths inside global.css correctly. Must NOT go through the
// Sass chain (see tailwind-entry.css). Imported before the SCSS bundle so the
// generated theme layers come first.
import "../scss/tailwind-entry.css";
import "../scss/styles.scss";

export const StylingWrapper = ({ children }: PropsWithChildren) => {
  return children;
};
